import { DesignOptions } from "@scenes/explore/utils/types";
import { useNavigationMenuSlice } from "@redux/slices/navigationMenuSlice";
import { useUserInfo } from "@redux/slices/userInfoSlice";
import { useTranslation } from "react-i18next";

const useProductArray = () => {
  const { getFilterData } = useNavigationMenuSlice();
  const filteredSections = getFilterData("search");
  const userInfo = useUserInfo();
  const { t } = useTranslation();

  const getTabsFilterData = (
    filteredArray: Array<any>,
    searchText: string
  ): Array<any> => {
    const tabFilteredArray = filteredArray.filter(
      (item) => item.type === searchText
    );

    return tabFilteredArray;
  };

  const tabFilterArray = getTabsFilterData(
    filteredSections[0].sub_section,
    DesignOptions.tabs
  );

  const tabOptionsFilterArray = getTabsFilterData(
    tabFilterArray[0].sub_section,
    DesignOptions.nav_option
  );

  const sortedSections = [...tabOptionsFilterArray[0].options]
    .filter((item: any) =>
      item?.price_modes?.includes(userInfo.user.price_mode)
    )
    .sort(
      (itemFirst: any, itemSecond: any) => itemFirst.order - itemSecond.order
    );

  const productArray = sortedSections
    .filter((item) => {
      return userInfo?.getAllowedStockTypes()?.includes(item.name);
    })
    .map((item, index) => {
      return {
        id: index,
        productType: item.name,
        title: t(item.label),
        icon: item.icon.data,
        type: item.icon.type,
        skipFilterScreenForWeb: item.skipFilterScreenForWeb ?? false,
        showFiltersOnStepTwo: item.show_filters_on_step_two ?? false,
        productColor: item.icon.icon_color,
        sectionName: item?.sectionName,
        hideSectionOnSplitScreen: item?.hideSectionOnSplitScreen ?? false,
        labelColor: item?.label_color,
        productPrefix: item?.productPrefix,
        options: item?.options || [],
        collection: item?.collection ?? "",
        is_collection: item?.is_collection ?? false,
        displaySubmenu: item?.displaySubmenu ?? false,
        deeplink: item?.deeplink,
        displayTabs: item?.displayTabs ?? false,
      };
    });

  const skipFilterScreen = (productType: string) => {
    const productObject = productArray.find(
      (_item) => _item.productType === productType
    );
    return productObject?.skipFilterScreenForWeb;
  };

  const showFiltersOnStepTwo = (productType: string) => {
    const productObject = productArray.find(
      (_item) => _item.productType === productType
    );
    return productObject?.showFiltersOnStepTwo;
  };

  const hideSectionOnSplitScreen = (productType: string) => {
    const productObject = productArray.find(
      (_item) => _item.productType === productType
    );
    return productObject?.hideSectionOnSplitScreen;
  };

  return {
    productArray,
    skipFilterScreen,
    showFiltersOnStepTwo,
    hideSectionOnSplitScreen,
  };
};

export default useProductArray;
